<template>
    <section>
        <video-player 
            class="vjs-custom-skin"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
        >
        </video-player>
    </section>
</template>

<script>
/**
 * 비디오 강의 미리보기 컴포넌트(video lesson preview component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import 'video.js/dist/video-js.css'
import '@/css/custom-player.css'
import { videoPlayer } from 'vue-video-player'

export default {
    props: ['previewData','thumbNail'],
    components: {
        videoPlayer
    },
    
    data() {
        return {
            
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [],
                poster: '',
                width: '100%',
                height:'100%',
                fluid: true,
                
            },
        }
        
    },

    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },

    mounted() {
        // set video player option
        setTimeout(() => {            
            this.playerOptions.sources = [{
                type: "video/mp4",
                src: this.previewData.video.file,
            }]

            // if (this.previewData.video.thumbnails) {
            //     this.playerOptions.poster = 
            //         this.previewData.video.thumbnails.length ? this.previewData.video.thumbnails[0] : require('@/images/video_thum.png')
            // }else {
            //     this.playerOptions.poster = require('@/images/video_thum.png')
            // }

            if (this.thumbNail) {
                this.playerOptions.poster = this.thumbNail
            }else {
                this.playerOptions.poster = require('@/images/video_thum.png')
            }
            
        }, 0)
        
    }


}
</script>
<style scoped>
/* .video-js .vjs-tech {
    position: unset;
} */
</style>